import { render } from "./KSClusterTableActions.vue?vue&type=template&id=3135d768"
import script from "./KSClusterTableActions.vue?vue&type=script&lang=js"
export * from "./KSClusterTableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__